module.exports = __webpack_public_path__ + "img/11069857_L.9a30454b.png";